import React, { useState } from "react";
import { Table, } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./VendorManagementDetails.module.css";
import { TextComponent } from "../../../../../components";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { useNavigate } from "react-router-dom";

const CustomerManagementDetails = () => {
    const navigate = useNavigate();

    const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderID",
            key: "OrderID",
        },
        {
            title: "Order Date",
            key: "OrderDate",
            dataIndex: "OrderDate",
        },

        {
            title: "Ingredients",
            dataIndex: "Ingredient",
            key: "Ingredient",
        },
        {
            title: "Quantity",
            key: "Quantity",
            dataIndex: "Quantity",
        },
        {
            title: "Cost",
            dataIndex: "Cost",
            key: "Cost",
        },

    ];

    const data = [
        {
            OrderID: "1001",
            OrderDate: "Jul 15, 2025",
            Ingredient: "All-Purpose Flours",
            Quantity: "1kg",
            Cost: "$150.00",
        },
        {
            OrderID: "1002",
            OrderDate: "Aug 03, 2025",
            Ingredient: "Granulated Sugar",
            Quantity: "1kg",
            Cost: "$120.00",
        },
        {
            OrderID: "1003",
            OrderDate: "Sep 12, 2025",
            Ingredient: "Active Dry Yeast",
            Quantity: "1kg",
            Cost: "$200.00",
        },
        {
            OrderID: "1004",
            OrderDate: "Oct 01, 2025",
            Ingredient: "Unsalted Butter",
            Quantity: "1kg",
            Cost: "$180.00",
        },
        {
            OrderID: "1005",
            OrderDate: "Nov 20, 2025",
            Ingredient: "Baking Powder",
            Quantity: "1kg",
            Cost: "$90.00",
        },

    ];
    const customerInfo = [
        { label: "Categories", value: "Ingredients" },
        { label: "Email", value: "Joshua@mail.com" },
        { label: "Notes", value: "Delivery before 10am" },
        { label: "Location", value: "417 Bicetown Road, New York, NY 10018" },
        { label: "Contact", value: "(636) 296-7838" },
    ];

    return (
        <div className={styles.mainCont}>
            <div className={styles.itemsHeadDiv}>
                <HeaderComponent
                    heading={"Pack Sure Solutions"}
                    showBackIcon={true}
                    showControlButtons={true}
                    onEdit={() => navigate("/AdminVendorManagement/AdminEditVendor")}
                />
            </div>

            <div className={styles.itemsContDiv}>
                <div className={styles.itemsContDivRow}>
                    {customerInfo.map((info, index) => (
                        <div className={styles.itemsDiv} key={index}>
                            <div className={styles.itemLabel}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}>
                                <TextComponent
                                    text={`${info.label} :`}
                                    style={{ fontFamily: "Poppins-bold" }}
                                />
                                <TextComponent
                                    text={info.value}
                                    style={{ fontFamily: "Poppins-regular" }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div>
                <HeaderComponent
                    heading={"Purchasing History"}
                    headingStyle={styles.headingStyle}
                    showFilterIcon={false}
                    showSubmitButton={false}
                    showSearch={false}
                />
            </div>

            <div className={styles.subCont}>
                <div className={styles.TableDiv}>
                    <Table
                        scroll={{ x: true }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        rowKey="No"
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomerManagementDetails;
